import type { FilterAstNode } from '@truss-security/truss-sdk-internal';
import type { ProductAttribute } from './types';

const equalsIgnoreCase = (a: string, b: string): boolean => a.toLowerCase() === b.toLowerCase();

export const isAstValueSelected = (
  ast: FilterAstNode | null,
  attribute: ProductAttribute,
  value: string
): boolean => {
  if (!ast) return false;

  if (ast.type === 'comparison') {
    return ast.attribute === attribute && ast.operator === '=' && equalsIgnoreCase(ast.value, value);
  }

  return isAstValueSelected(ast.left, attribute, value) || isAstValueSelected(ast.right, attribute, value);
};

export const getAstSelectedValues = (
  ast: FilterAstNode | null,
  attribute: ProductAttribute
): string[] => {
  if (!ast) return [];

  const values: string[] = [];
  const seen = new Set<string>();

  const visit = (node: FilterAstNode) => {
    if (node.type === 'comparison') {
      if (node.attribute === attribute && node.operator === '=') {
        const normalized = node.value.toLowerCase();
        if (!seen.has(normalized)) {
          seen.add(normalized);
          values.push(node.value);
        }
      }
      return;
    }

    visit(node.left);
    visit(node.right);
  };

  visit(ast);
  return values;
};
